var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,1.25C23.08,1.25,1.25,23.08,1.25,50s21.83,48.75,48.75,48.75,48.75-21.82,48.75-48.75S76.93,1.25,50,1.25ZM57.11,13.15c10.05,0,18.23,8.18,18.23,18.23s-8.18,18.23-18.23,18.23-18.23-8.18-18.23-18.23,8.18-18.23,18.23-18.23ZM37.21,80.72l-10.16,5.87c-.96.55-2.19.22-2.75-.74l-10.38-17.98c-.56-.96-.22-2.19.74-2.75l10.16-5.86c.96-.56,2.2-.22,2.75.74l10.38,17.98c.55.96.22,2.19-.74,2.75ZM70.6,71.14c-1.13.82-2.18,1.49-3.16,2.05-2.82,1.62-6.03,2.46-9.28,2.46h-16.57l-8.83-15.3c2.26-4.6,7.71-8.05,13.18-8.05,3.08,0,5.92,1,8.22,2.7.67.49,1.29,1.05,1.86,1.65h8.42c1.55,0,2.86,1.2,2.93,2.74.07,1.63-1.23,2.98-2.86,2.98h-11.06c-1.19,0-2.16.96-2.16,2.16s.97,2.16,2.16,2.16h10.34c1.5,0,2.95-.42,4.19-1.2.32-.2.62-.42.91-.67.63-.45,8.53-6.14,12.64-9.11,1.36-.98,3.25-.67,4.22.68.98,1.36.67,3.25-.69,4.23,0,0-9.72,7.1-14.48,10.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagos);
export default __webpack_public_path__ + "static/media/Pagos.852040ef443aa6c2cb58542a0b2df4bf.svg";
export { ForwardRef as ReactComponent };